import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { IFrameworkResource } from "../../frameworks";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ISkillItem, ISkillLevelLight } from "../types";

export type ISkillLevelData = Pick<ISkillLevelLight, "actions" | "evalCriteria">;

export type ISkillCreateMutationParameters = {
    officialTitle: string;
    shortTitle: string;
    skillLevel1: ISkillLevelData;
    skillLevel2: ISkillLevelData;
    skillLevel3: ISkillLevelData;
    uuid?: string;
    frameworks?: RelationalValue<IFrameworkResource>[];
    rank?: number;
};

export type ISkillCreateMutationResult = ISkillItem;

export const skillCreateMutation: IApiMutationFunction<ISkillCreateMutationParameters> = ({
    uuid: providedUuid,
    officialTitle,
    shortTitle,
    skillLevel1,
    skillLevel2,
    skillLevel3,
    frameworks,
    rank,
}) => {
    return {
        method: "POST",
        url: "/skills",
        data: {
            officialTitle,
            shortTitle,
            skillLevel1,
            skillLevel2,
            skillLevel3,
            frameworks: frameworks?.map(framework => mapRelationalValueAsIRI(EntityTypes.FRAMEWORK, framework)),
            rank,
            uuid: providedUuid ?? uuid(),
        },
    };
};

export const useSkillCreateMutation = createApiMutationHook<ISkillCreateMutationParameters, ISkillCreateMutationResult>(
    skillCreateMutation,
);
